const config = JSON.parse(
  document.getElementById('js-bundle-runtime-config').innerHTML,
);

const castToBoolean = (value) => /^\s*(true|1|on|yes)\s*$/i.test(`${value}`);

config.defaultBuyer = config.CONFIG_ASN_DEFAULT_BUYER;
config.allowUserSetUOM = config.CONFIG_ASN_ALLOW_SET_UOM;
config.asnDisablePartSourceCheck = config.CONFIG_ASN_DISABLE_PART_SOURCE_CHECK;
config.useManualOrders = castToBoolean(config.CONFIG_USE_MANUAL_ORDERS);
config.useAutoOrders = !config.useManualOrders;

config.ssoLocalRolesAndCode = castToBoolean(config.CONFIG_SSO_LOCAL_ROLES_N_CODE);

config.dateFormat = 'YYYY-MM-DD';

config.styleName = (config.STYLE_NAME || 'sollers').toLowerCase();

const workMode = (config.WORK_MODE || 'sollers').toLowerCase();

config.workMode = {
  isModeAurus: workMode === 'aurus',
  isModeSollers: workMode === 'sollers',
  isModeArgo: workMode === 'uaz',
};

config.castToBoolean = castToBoolean;

export default config;
